import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Button, Card } from "react-bootstrap";
import AdminSidebar from "../AdminSidebar";
import { IoMdAddCircle } from "react-icons/io";
import Select from "react-select";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import axios from 'axios';
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Fill } from "react-icons/ri";
import ConfirmDialog from "../../components/ToastNotification/ConfirmModal";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";
import { MdOutlinePerson4 } from "react-icons/md";
function ManageStaff() {
  const [showForm, setShowForm] = useState(false);
  const [getStaff, setGetStaff] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [services, setServices] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [showPreview, setShowPreview] = useState({
    identity: false,
    pan: false
  });
  const [showStaffModal, setShowStaffModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    pass: '',
    address: '',
    basic_salary: '',
    profile_img: null,
    identity_file: null,
    doc_pan: null,
    gender: '',
    age: '',
    latitude: "",
    longitude: "",
    bank_name: '',
    acc_no: '',
    ifsc: '',
    holder_name: '',
    isActive: '',
    con_acc_no: '',
    com_amount: ''
  });
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const genderOptions = [{
    value: "male",
    label: "Male"
  }, {
    value: "female",
    label: "Female"
  }, {
    value: "other",
    label: "Other"
  }];
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const showConfirmDialog = ({
    title,
    message,
    onConfirm
  }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({
          ...confirmDialog,
          show: false
        });
      }
    });
  };
  const handleInputChange = e => {
    const {
      name,
      value,
      files
    } = e.target;
    if (name === "image") {
      setFormData({
        ...formData,
        [name]: files[0]
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleAddNew = () => {
    setIsEditMode(false);
    resetForm();
    setShowForm(true);
  };
  const handleCancel = () => {
    setShowForm(false);
    setIsEditMode(false);
    resetForm();
  };
  const getAddress = address => {
    try {
      const parsed = JSON.parse(address);
      if (!parsed) return "-";
      const {
        name,
        subLocality,
        locality,
        state,
        country,
        pincode
      } = parsed;
      return [name, subLocality, locality, state, country, pincode].filter(Boolean).join(", ");
    } catch {
      return "-";
    }
  };
  const formatAddress = value => {
    if (!value) return null;
    const parts = value.split(",").map(p => p.trim());
    return {
      name: parts[0] || "",
      subLocality: parts[1] || "",
      locality: parts[2] || "",
      state: parts[3] || "",
      country: "India",
      pincode: parts[4] || ""
    };
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.name) {
      showToast("Service name is required!", "danger");
      return;
    }
    if (formData.acc_no != formData.con_acc_no) {
      showToast("Account numbers do not match!", "danger");
      return;
    }
    try {
      const toNull = v => v === undefined || v === "" ? null : v;
      const formattedAddress = formatAddress(formData.address);
      const sendData = new FormData();
      sendData.append("name", formData.name);
      sendData.append("mobile", formData.mobile);
      sendData.append("email", formData.email);
      sendData.append("pass", formData.pass);
      // sendData.append("address", formData.address);

      sendData.append("address", JSON.stringify(formattedAddress));
      sendData.append("basic_salary", toNull(formData.basic_salary));
      sendData.append("gender", toNull(formData.gender));
      sendData.append("age", toNull(formData.age));
      sendData.append("bank_name", toNull(formData.bank_name));
      sendData.append("acc_no", toNull(formData.acc_no));
      sendData.append("ifsc", toNull(formData.ifsc));
      sendData.append("holder_name", toNull(formData.holder_name));
      if (isEditMode) sendData.append("com_amount", toNull(formData.com_amount));
      if (formData.profile_img) {
        const maxSizeMB = 2;
        const fileSizeMB = formData.profile_img.size / (1024 * 1024);
        if (fileSizeMB > maxSizeMB) {
          showToast("Image size must be less than 2MB!", "danger");
          return;
        }
        sendData.append("profile_img", formData.profile_img);
      }
      if (Array.isArray(formData.identity_file)) {
        for (let file of formData.identity_file) {
          if (file.size / (1024 * 1024) > 2) {
            showToast(`File ${file.name} exceeds 2MB`, "danger");
            return;
          }
          sendData.append("identity_file", file);
        }
      }
      if (Array.isArray(formData.doc_pan)) {
        for (let file of formData.doc_pan) {
          if (file.size / (1024 * 1024) > 2) {
            showToast(`File ${file.name} exceeds 2MB`, "danger");
            return;
          }
          sendData.append("doc_pan", file);
        }
      }
      let res;
      if (isEditMode) {
        res = await axios.put(`https://api.sweepydo.in/update-staff/${formData.id}`, sendData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        showToast("Staff Updated Successfully!", "success");
      } else {
        res = await axios.post("https://api.sweepydo.in/add-staff", sendData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        showToast("Staff Added Successfully!", "success");
      }
      setShowForm(false);
      setIsEditMode(false);
      resetForm();
      fetchSetaff();
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      showToast("Failed to save service!", "danger");
    }
  };
  const handleEdit = async form => {
    setIsEditMode(true);
    let identityFiles = [];
    let identityPreview = [];
    let identityType = [];
    let panFiles = [];
    let panPreview = [];
    let panType = [];
    try {
      if (form.identity_file) {
        const parsed = JSON.parse(form.identity_file);
        identityFiles = parsed;
        identityPreview = parsed.map(file => `https://api.sweepydo.in/uploads/${file}`);
        identityType = parsed.map(file => file.match(/\.(jpg|jpeg|png)$/i) ? "image" : "file");
      }
    } catch (e) {
      console.log("identity parse error");
    }
    try {
      if (form.doc_pan) {
        const parsed = JSON.parse(form.doc_pan);
        panFiles = parsed;
        panPreview = parsed.map(file => `https://api.sweepydo.in/uploads/${file}`);
        panType = parsed.map(file => file.match(/\.(jpg|jpeg|png)$/i) ? "image" : "file");
      }
    } catch (e) {}
    setFormData({
      id: form.id,
      name: form.name || "",
      mobile: form.mobile || "",
      email: form.email || "",
      pass: form.pass || "",
      // address: form.address || "",
      address: form.address ? getAddress(form.address) : "",
      basic_salary: form.basic_salary || "",
      profile_img: null,
      identity_file: identityFiles,
      identityPreview: identityPreview,
      identityType: identityType,
      doc_pan: panFiles,
      panPreview: panPreview,
      panType: panType,
      gender: form.gender || "",
      age: form.age || "",
      latitude: form.latitude || "",
      longitude: form.longitude || "",
      bank_name: form.bank_name || '',
      acc_no: form.acc_no || '',
      con_acc_no: form.acc_no || "",
      ifsc: form.ifsc || '',
      holder_name: form.holder_name || '',
      com_amount: form.com_amount || '',
      imagePreview: form.profile_img ? `https://api.sweepydo.in/uploads/${form.profile_img}` : ""
    });
    setEditingCompanyId(form.id);
    setShowForm(true);
  };
  const handleDelete = async id => {
    try {
      await axios.delete(`https://api.sweepydo.in/delete-staff/${id}`);
      showToast("Staff  deleted successfully");
      fetchSetaff();
    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete staff");
    }
  };
  const handleToggleStatus = async id => {
    try {
      await axios.put(`https://api.sweepydo.in/toggle-staff-status/${id}`);
      showToast("Status updated!", "success");
      fetchSetaff();
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "danger");
    }
  };
  const handleMakeStaff = async id => {
    try {
      const res = await axios.put(`https://api.sweepydo.in/make-staff/${id}`, {
        is_staff: 1
      });
      if (res.status === 200) {
        showToast("Staff confirmed successfully", 'success');
        fetchSetaff();
      } else {
        showToast(res.data.message || "Something went wrong", 'danger');
      }
    } catch (error) {
      console.log(error);
      showToast(error.response?.data?.message || "Server error", 'danger');
    }
  };
  const fetchSetaff = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-all-staff");
      const sortedData = res.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setGetStaff(sortedData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchSetaff();
  }, []);
  const resetForm = () => {
    setFormData({
      name: "",
      mobile: "",
      email: "",
      pass: '',
      address: '',
      basic_salary: '',
      profile_img: null,
      identity_file: null,
      imagePreview: "",
      identityPreview: ""
    });
  };
  const filteredData = Array.isArray(getStaff) ? getStaff.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  return <div className="container-fluid mt-1 p-4" style={{
    minHeight: "100vh"
  }}>

      <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
      <h2 className="text-center mb-4 text-white">Manage Staff </h2>




      {showForm && <Card className="Card p-3" style={{
      background: "var(--black)",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "12px",
      boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
      marginBottom: "20px"
    }}>
          <form onSubmit={handleSubmit}>
            <div className="row">


              <div className="col-md-4 d-flex flex-column align-items-center justify-content-center border-end">

                <label className="form-label">Profile Image</label>

                <img src={formData.imagePreview || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} alt="Profile" className="rounded-circle mb-3" style={{
              width: "200px",
              height: "200px",
              objectFit: "cover"
            }} />

              </div>

              <div className="col-md-8">


                <div className="row mb-3">
                  <div className="col-md-6">
                    <label>Name</label>
                    <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="form-control" required />
                  </div>

                  <div className="col-md-6">
                    <label>Phone</label>
                    <input type="text" name="mobile" value={formData.mobile} onChange={handleInputChange} className="form-control" maxLength={10} required />
                  </div>
                </div>


                <div className="row mb-3">
                  <div className="col-md-6">
                    <label>Email</label>
                    <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="form-control" required />
                  </div>

                  <div className="col-md-6">
                    <label>Password</label>
                    <input type="text" name="pass" value={formData.pass} onChange={handleInputChange} className="form-control" />
                  </div>
                </div>


                <div className="row mb-3">
                  <div className="col-md-6">
                    <label>Age</label>
                    <input type="number" name="age" value={formData.age} onChange={handleInputChange} className="form-control" />
                  </div>

                  <div className="col-md-6">
                    <label>Gender</label>

                    <Select name="gender" value={genderOptions.find(option => option.value === formData.gender)} onChange={selectedOption => setFormData({
                  ...formData,
                  gender: selectedOption ? selectedOption.value : ""
                })} options={genderOptions} className="" classNamePrefix="custom-select" />
                  </div>
                </div>

                {/* Salary + Address */}


                <div className="row mb-3">
                  <div className="col-md-6">
                    <label>Basic Salary</label>
                    <input type="number" name="basic_salary" value={formData.basic_salary} onChange={handleInputChange} className="form-control" />
                  </div>

                  <div className="col-md-6">
                    <label>Bank Name</label>
                    <input type="text" name="bank_name" value={formData.bank_name} onChange={handleInputChange} className="form-control" />
                  </div>
                </div>



                <div className="row mb-3">
                  <div className="col-md-6">
                    <label>Bank Account No</label>
                    <input type="text" name="acc_no" value={formData.acc_no} onChange={handleInputChange} className="form-control" />
                  </div>


                  <div className="col-md-6">
                    <label>Confirmed Account No</label>
                    <input type="text" name="con_acc_no" value={formData.con_acc_no} onChange={handleInputChange} className="form-control" />
                  </div>
                </div>

                <div className="row mb-3">

                  <div className="col-md-6">
                    <label>IFSC</label>
                    <input type="text" name="ifsc" value={formData.ifsc} onChange={handleInputChange} className="form-control" />
                  </div>


                  <div className="col-md-6">
                    <label>Account holder Name</label>
                    <input type="text" name="holder_name" value={formData.holder_name} onChange={handleInputChange} className="form-control" />
                  </div>
                </div>


                <div className="row mb-3">
                  <div className="col-md-6">
                    <label>Address</label>

                    <textarea name="address" value={formData.address} onChange={handleInputChange} placeholder="Enter Region  City " className="form-control" rows={4}
                //  required
                />

                  </div>

                  <div className="col md-6">
                    <label>Upload Profile Image</label>

                    <input type="file" accept="image/*" name="profile_img" className="form-control" onChange={e => {
                  const file = e.target.files[0];
                  setFormData({
                    ...formData,
                    profile_img: file,
                    imagePreview: URL.createObjectURL(file)
                  });
                }} />
                  </div>

                </div>

                <div className="row mb-3">

                  <div className="col-md-6">
                    <label className="form-label">Upload Aadhaar</label>

                    <input type="file" name="identity_file" className="form-control" accept="image/*,.pdf" multiple onChange={e => {
                  const files = Array.from(e.target.files);
                  setFormData({
                    ...formData,
                    identity_file: files,
                    identityPreview: files.map(file => URL.createObjectURL(file)),
                    identityType: files.map(file => file.type)
                  });
                  setShowPreview(prev => ({
                    ...prev,
                    identity: false
                  })); // reset
                }} />

{isEditMode && <div className="col-md-6 mt-3">
                    <label>Staff Commission</label>
                    <input type="text" name="com_amount" value={formData.com_amount} onChange={handleInputChange} className="form-control" />
                  </div>}

                    {formData.identityPreview?.length > 0 && <button type="button" className="btn btn-sm btn-primary mt-2" onClick={() => setShowPreview(prev => ({
                  ...prev,
                  identity: !prev.identity
                }))}>
                        {showPreview.identity ? "Hide Preview" : "Preview Files"}
                      </button>}


                    {showPreview.identity && <div className="d-flex flex-wrap gap-2 mt-2">
                        {formData.identityPreview.map((src, i) => <div key={i}>
                            {formData.identityType[i]?.startsWith("image") ? <img src={src} className="img-thumbnail" width={100} /> : <a href={src} target="_blank" rel="noreferrer">
                                📄 File {i + 1}
                              </a>}
                          </div>)}
                      </div>}
                  </div>




                  <div className="col-md-6">
                    <label>Upload PAN</label>

                    <input type="file" name="doc_pan" className="form-control" multiple onChange={e => {
                  const files = Array.from(e.target.files);
                  setFormData({
                    ...formData,
                    doc_pan: files,
                    panPreview: files.map(file => URL.createObjectURL(file)),
                    panType: files.map(file => file.type)
                  });
                  setShowPreview(prev => ({
                    ...prev,
                    pan: false
                  }));
                }} />





                    {formData.panPreview?.length > 0 && <button type="button" className="btn btn-sm btn-primary mt-2" onClick={() => setShowPreview(prev => ({
                  ...prev,
                  pan: !prev.pan
                }))}>
                        {showPreview.pan ? "Hide Preview" : "Preview Files"}
                      </button>}


                    {showPreview.pan && <div className="d-flex flex-wrap gap-2 mt-2">
                        {formData.panPreview.map((src, i) => <div key={i}>
                            {formData.panType[i]?.startsWith("image") ? <img src={src} className="img-thumbnail" width={100} /> : <a href={src} target="_blank" rel="noreferrer">
                                📄 File {i + 1}
                              </a>}
                          </div>)}
                      </div>}
                  </div>

                </div>



                <div className="d-flex justify-content-end">
                  <Button type="submit" variant="success">
                    {isEditMode ? "Update" : "Save"}
                  </Button>

                  <Button variant="danger" onClick={handleCancel} className="ms-2">
                    Cancel
                  </Button>
                </div>

              </div>
            </div>
          </form>
        </Card>}

      {!showForm && <div style={{
      background: "var(--black)",
      borderRadius: "12px",
      padding: "15px"
    }}>
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

            {/* Left: Search */}
            <input type="text" className="form-control p-2 " style={{
          maxWidth: "300px"
        }} placeholder="Search staff by name,phone..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />




            <button className="btn  btn-primary btn-lg  " onClick={handleAddNew}> <IoAdd className="me-2" /> Add Staff </button>
          </div>


          <div className='table-responsive '>
            <table style={{
          width: "100%",
          borderCollapse: "collapse",
          color: "#fff"
        }}>
              <thead>
                <tr style={{
              backgroundColor: "var(--black2)"
            }}>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>SN</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}> Name</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Phone</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Email</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Basic Salary </th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Action</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Confirm Employee</th>
                </tr>
              </thead>
              <tbody>

                {filteredData.map((s, i) => <tr key={s.id} style={{
              backgroundColor: "var(--black)",
              borderBottom: "1px solid rgba(255,255,255,0.06)",
              transition: "0.3s"
            }} onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = "var(--black2)";
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "var(--black)";
            }}>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}> {filteredData.length - i}</td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.name} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.mobile} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.email} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.basic_salary} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}><FaEdit size={20} cursor='pointer' title="Edit" className="text-primary" onClick={() => handleEdit(s)} />
                      <RiDeleteBin6Fill size={20} cursor='pointer' title="Delete" className="mx-2 text-danger" onClick={() => showConfirmDialog({
                  title: 'Delete Staff',
                  message: `Are you sure you want to delete  this staff ?`,
                  onConfirm: () => handleDelete(s.id)
                })} />

                      <MdOutlinePerson4 size={20} cursor="pointer" title={s.isActive == 0 ? "Deactivate Staff" : "Activate Staff"} className={`mx-2 ${s.isActive == 0 ? "text-warning" : "text-secondary"}`} onClick={() => {
                  setSelectedStaff(s);
                  setShowStatusModal(true);
                }} />
                    </td>

<td style={{
                padding: "18px",
                textAlign: "center"
              }}>
  {s.is_staff == 1 ? <button className="btn btn-secondary btn-sm" disabled>
      Already Confirmed
    </button> : <button className="btn btn-success btn-sm" onClick={() => {
                  setSelectedStaff(s);
                  setShowStaffModal(true);
                }}>
      Confirm
    </button>}
</td>
                  </tr>)}
              </tbody>
            </table>
          </div>

        </div>}




      <ConfirmDialog show={confirmDialog.show} title={confirmDialog.title} message={confirmDialog.message} onConfirm={confirmDialog.onConfirm} onCancel={() => setConfirmDialog({
      ...confirmDialog,
      show: false
    })} />

      {showStatusModal && <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{
          backgroundColor: "var(--black2)",
          color: "#fff"
        }}>

              <div className="modal-header">
                <h5 className="modal-title">Mark {selectedStaff.isActive == 0 ? 'Inactive' : 'Active'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowStatusModal(false)}></button>
              </div>

              <div className="modal-body">
                <p>Are you sure you want to change this staff status?</p>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowStatusModal(false)}>
                  Cancel
                </button>

                <button className="btn btn-warning" onClick={() => {
              handleToggleStatus(selectedStaff.id);
              setShowStatusModal(false);
            }}>
                  Yes, Change
                </button>
              </div>

            </div>
          </div>
        </div>}



 {showStaffModal && <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content" style={{
          backgroundColor: "var(--black2)",
          color: "#fff"
        }}>

        <div className="modal-header">
          <h5 className="modal-title">
            Confirm Staff - {selectedStaff?.name}
          </h5>
          <button type="button" className="btn-close" onClick={() => setShowStaffModal(false)}></button>
        </div>

        <div className="modal-body">
          <p>
            Are you sure you want to confirm{" "}
            <strong>{selectedStaff?.name}</strong> as staff?
          </p>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowStaffModal(false)}>
            Cancel
          </button>

          <button className="btn btn-success" onClick={() => {
              handleMakeStaff(selectedStaff.id);
              setShowStaffModal(false);
            }}>
            Yes, Confirm
          </button>
        </div>

      </div>
    </div>
  </div>}

    </div>;
}
export default ManageStaff;
